module.exports = __webpack_public_path__ + "static/img/main.2994edaa.jpg";